import { VAPID_KEY } from "@/utils/auth";
import { decode as decodeBase64 } from "@/utils/base64";

// Last one checks for payload support: https://web-push-book.gauntface.com/chapter-06/01-non-standards-browsers/#no-payload
const supportsPushNotifications =
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "getKey" in PushSubscription.prototype &&
  "requestPermission" in Notification;

// Taken from https://www.npmjs.com/package/web-push
const urlBase64ToUint8Array = (base64String: string) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  return decodeBase64(base64);
};

const getApplicationServerKey = () => urlBase64ToUint8Array(VAPID_KEY);

async function getRegistration() {
  if (navigator.serviceWorker) {
    return navigator.serviceWorker.ready;
  } else {
    throw "Your browser does not support Service Workers.";
  }
}

async function getPushSubscription(registration: ServiceWorkerRegistration) {
  return registration.pushManager
    .getSubscription()
    .then((subscription) => ({ registration, subscription }));
}

const subscribetoPushNotifications = (
  registration: ServiceWorkerRegistration,
) => {
  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: getApplicationServerKey(),
  });
};

const unsubscribeFromPushNotifications = ({
  registration,
  subscription,
}: {
  registration: ServiceWorkerRegistration;
  subscription: PushSubscription | null;
}) => {
  return subscription
    ? subscription.unsubscribe().then(() => registration)
    : new Promise<ServiceWorkerRegistration>((r) => r(registration));
};

export {
  getApplicationServerKey,
  supportsPushNotifications,
  getRegistration,
  getPushSubscription,
  subscribetoPushNotifications,
  unsubscribeFromPushNotifications,
};
